import React from 'react'
import moment from 'moment-timezone'
import BaseTick from './BaseTick'
import { useTranslation } from '@morningtrain/react-translations'

function CustomTimeTick (props) {
  const {
    mode,
    payload
  } = props

  const value = payload.value

  const valueAsMoment = moment.unix(value).tz('Europe/London')
  const weekTrans = useTranslation('generic.week')

  const getTickHeader = () => {
    switch (mode) {
      case 'hourly':
        return valueAsMoment.format('HH:mm')
      case 'weekly':
        return weekTrans + ' ' + valueAsMoment.isoWeek()
      case 'monthly':
        return valueAsMoment.format('MMM')
      case 'monthly-day':
        return valueAsMoment.format('MMM DD')
      default:
        return valueAsMoment.format('DD')
    }
  }

  const getTickSubtitle = () => {
    switch (mode) {
      case 'hourly':
        return ''
      case 'weekly':
        return valueAsMoment.isoWeekYear()
      case 'monthly':
        return valueAsMoment.format('YYYY')
      case 'monthly-day':
        return valueAsMoment.format('YYYY')
      default:
        return valueAsMoment.format('ddd')
    }
  }

  return (
    <BaseTick
      {...props}
      header={getTickHeader()}
      subtitle={getTickSubtitle()}
    />
  )
}

export default React.memo(CustomTimeTick)
